// === FUNCIONES GENERALES ===

function mostrarContenido() {
    document.getElementById("MainContent").style.display = "block";
    let header = document.querySelector(".m-header__wrapper");
    if (header) header.style.display = "block";
}

/*
function validarAcceso() {
    console.log("✅ Página cargada. Verificando acceso...");
    let phone = document.getElementById("inputphone").value.trim();
    console.warn("🆔 Cédula ingresada:", phone);

    if (!phone) {
        alert("⚠ Por favor ingrese su cédula.");
        toggleLoading(false);
        return;
    }

    let url = `https://script.google.com/macros/s/AKfycbwiHKOtLBBEiq_X-xpUnOsdxjwRdX2AJk9Y5znX8T2r5PSpzDkSkeD_VWUQdUlLPWzLdg/exec?phone=${phone}`;
    console.warn("🌍 Consultando API:", url);

    fetch(url)
        .then(response => response.json())
        .then(data => {
            let respuesta = data.existe ? data.existe.trim().toLowerCase() : "";
            if (respuesta === "yes" || respuesta === "sí") {
                localStorage.setItem("accesoPermitido", "true");
                localStorage.setItem("phone", data.phone);
                localStorage.setItem("tipoPrecio", data.precio);
                localStorage.setItem("nombre", data.nombre);
                document.getElementById("nombreUsuario").textContent = data.nombre;
                document.getElementById("mensajeAcceso").style.display = "none";
                document.getElementById("mensajeAccesoAprobado").style.display = "block";
                setTimeout(() => {
                    window.location.href = "/collections/all";
                }, 1000); // o menos si no necesitas retraso
            } else {
                alert("❌ Acceso denegado. Esta cédula no está registrada.");
            }
        })
        .catch(error => {
            console.warn("❌ Error en la verificación:", error);
            alert("⚠ Error al conectar con la base de datos.");
        })
        .finally(() => toggleLoading(false));
}
*/

function validarAcceso() {
    console.log("✅ Página cargada. Verificando acceso...");

    let phone = document.getElementById("inputphone").value.trim();
    console.warn("🆔 Celular ingresado:", phone);

    if (!phone) {
        alert("⚠ Por favor ingrese su número de celular.");
        toggleLoading(false);
        return;
    }

    let url = `https://script.google.com/macros/s/AKfycbwiHKOtLBBEiq_X-xpUnOsdxjwRdX2AJk9Y5znX8T2r5PSpzDkSkeD_VWUQdUlLPWzLdg/exec?phone=${phone}`;
    console.warn("🌍 Consultando API:", url);

    fetch(url)
        .then(response => response.json())
        .then(data => {
            console.warn("📩 Respuesta de la API:", data);
            let respuesta = data.existe ? data.existe.trim().toLowerCase() : "";

            if (respuesta === "yes" || respuesta === "sí") {
                console.warn("✅ Acceso permitido. Limpiando datos anteriores...");

                // Limpiar datos anteriores
                localStorage.removeItem("accesoPermitido");
                localStorage.removeItem("phone");
                localStorage.removeItem("tipoPrecio");
                localStorage.removeItem("nombre");
                localStorage.removeItem("cliente_expira");

                // Guardar nuevos datos
                localStorage.setItem("accesoPermitido", "true");
                localStorage.setItem("phone", data.phone);
                localStorage.setItem("tipoPrecio", data.precio);
                localStorage.setItem("nombre", data.nombre);

                // Redirigir a la colección
                setTimeout(() => {
                    window.location.href = "/collections/all";
                }, 1000);
            } else {
                console.warn("⛔ Acceso denegado. Celular no registrado.");
                alert("❌ Este número no está registrado.");
            }
        })
        .catch(error => {
            console.warn("❌ Error de conexión:", error);
            alert("⚠ No se pudo conectar con la base de datos.");
        })
        .finally(() => {
            toggleLoading(false);
        });
}


function getClienteInfo() {
    const expiracion = localStorage.getItem("cliente_expira");
    const ahora = Date.now();
    if (expiracion && ahora > parseInt(expiracion)) {
        localStorage.clear();
        return null;
    }
    return {
        phone: localStorage.getItem("phone"),
        tipoPrecio: localStorage.getItem("tipoPrecio"),
        nombre: localStorage.getItem("nombre")
    };
}

function toggleLoading(isLoading) {
    let boton = document.querySelector("#btnIngresar");
    boton.innerHTML = isLoading ? `<div class="spinner"></div> Validando...` : "Ingresar";
    boton.disabled = isLoading;
}

async function actualizarYAplicarTipoPrecio() {
    const phone = localStorage.getItem("phone");
    if (!phone) return;

    const ahora = Date.now();
    const expiracion = parseInt(localStorage.getItem("cliente_expira") || 0);
    if (expiracion && ahora > expiracion) {
        localStorage.clear();
        document.cookie = "tipoPrecio=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.body.removeAttribute("data-precio");
        return;
    }

    const url = `https://script.google.com/macros/s/AKfycbwiHKOtLBBEiq_X-xpUnOsdxjwRdX2AJk9Y5znX8T2r5PSpzDkSkeD_VWUQdUlLPWzLdg/exec?phone=${phone}`;
    try {
        const response = await fetch(url);
        const data = await response.json();
        if (data && (data.existe.toLowerCase() === "yes" || data.existe.toLowerCase() === "sí")) {
            const tipoPrecio = data.precio?.toUpperCase();
            localStorage.setItem("tipoPrecio", tipoPrecio);
            localStorage.setItem("nombre", data.nombre);
            localStorage.setItem("cliente_expira", ahora + 15 * 60 * 1000);
            document.cookie = `tipoPrecio=${tipoPrecio}; path=/;`;
            document.body.setAttribute("data-precio", tipoPrecio);
            aplicarPreciosDesdeTags();
            observarNuevosProductos();
        } else {
            document.body.removeAttribute("data-precio");
        }
    } catch (error) {
        console.error("❌ Error consultando la API:", error);
    }
}

function aplicarPreciosDesdeTags() {
    const tipoPrecioCliente = document.body.dataset.precio;
    if (!tipoPrecioCliente) {
        document.querySelectorAll(".m-price-item").forEach(el => el.style.display = "none");
        return;
    }

    document.querySelectorAll(".m-product-custom-price").forEach((tagEl) => {
        const tipo = tagEl.dataset.tipoPrecio;
        const precio = tagEl.dataset.precio;
        const productoID = tagEl.dataset.productId;
        if (tipoPrecioCliente === tipo) {
            const precioEl = document.querySelector(`.m-price-item[data-product-id="${productoID}"]`);
            if (precioEl) {
                precioEl.textContent = `$${parseFloat(precio).toLocaleString("es-CO")} COP`;
                precioEl.style.display = "block";
                precioEl.style.color = "#000000";
            }
        }
    });
}

function observarNuevosProductos() {
    const contenedor = document.querySelector('.m-collection-products');
    if (!contenedor) return;

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.addedNodes.length > 0) {
                aplicarPreciosDesdeTags();
                break;
            }
        }
    });

    observer.observe(contenedor, { childList: true, subtree: true });
}

function openModal() {
    const modal = document.getElementById("whatsappModal");
    const grid = document.getElementById("imageGrid");
    // Todas las imágenes dentro del grid, excepto las de productos con clase .none
    const images = document.querySelectorAll("#CollectionProductGrid .m-product-item:not(.none) img");
    grid.innerHTML = "";
    selected = [];

    images.forEach((img, i) => {
        const src = img.src.split("?")[0];
        const wrapper = document.createElement("div");
        wrapper.style = "border:2px solid transparent; padding:5px;";
        wrapper.innerHTML = `<img src="${src}" data-index="${i}" style="width:120px; height:120px; object-fit:cover; cursor:pointer;" />`;
        wrapper.onclick = function () {
            if (selected.includes(src)) {
                selected = selected.filter(s => s !== src);
                wrapper.style.border = "2px solid transparent";
            } else {
                selected.push(src);
                wrapper.style.border = "2px solid black";
            }
            updateCount();
        };
        grid.appendChild(wrapper);
    });

    document.getElementById("selectAllBtn").onclick = function () {
        selected = [];
        document.querySelectorAll("#imageGrid img").forEach(img => {
            const src = img.src.split("?")[0];
            selected.push(src);
            img.parentElement.style.border = "2px solid black";
        });
        updateCount();
    };

    document.getElementById("downloadZipBtn").onclick = async function () {
        if (selected.length === 0) return alert("Selecciona al menos una imagen.");
        const zip = new JSZip();
        let count = 1;
        for (let url of selected) {
            const blob = await fetch(url).then(r => r.blob());
            zip.file(`producto_${count++}.jpg`, blob);
        }
        const content = await zip.generateAsync({ type: "blob" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(content);
        a.download = "imagenes_catalogo.zip";
        a.click();
    };

    document.getElementById("catalogoBtn").onclick = async function () {
        if (selected.length === 0) return alert("Selecciona al menos una imagen.");
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: [150, 150] });
        for (let i = 0; i < selected.length; i++) {
            const imageData = await fetch(selected[i])
                .then(res => res.blob())
                .then(blob => new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(blob);
                }));
            doc.addImage(imageData, "PNG", 0, 0, 150, 150, undefined, 'FAST');
            if (i < selected.length - 1) doc.addPage();
        }
        doc.save("catalogo_productos.pdf");
    };

    function updateCount() {
        document.getElementById("selectionCount").textContent = `${selected.length} seleccionadas`;
    }
  // Cerrar: botón X, botón “Cerrar” y tecla ESC
  const closeModal = () => modal.style.display = "none";
  document.getElementById("closeModalBtn").onclick  = closeModal;
  document.getElementById("closeModalBtn2").onclick = closeModal;
  document.addEventListener("keydown", function escHandler(e){
    if (e.key === "Escape") { closeModal(); document.removeEventListener("keydown", escHandler); }
  });
    modal.style.display = "flex";
}

// === EVENTO PRINCIPAL ===

document.addEventListener("DOMContentLoaded", () => {
    actualizarYAplicarTipoPrecio();

    if (localStorage.getItem("accesoPermitido")) {
        console.clear();
        mostrarContenido();
        getClienteInfo();
    }
  
    const btnIngresar = document.querySelector("#btnIngresar");
    if(btnIngresar){
      btnIngresar.addEventListener("click", () => {
          console.clear();
          toggleLoading(true);
          validarAcceso();
      });
    }
  
    //const iconSvgDescargar = '<svg xmlns="http://www.w3.org/2000/svg" fill="white" width="20" height="20" viewBox="0 0 24 24"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.893-11.893 11.893-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.653zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.15-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.151-.174.2-.298.3-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>';
    const iconSvgDescargar = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 64 64"><rect width="64" height="64" rx="12" ry="12" fill="#25d366"/><path d="M32 20v24M32 44l-8-8M32 44l8-8" stroke="#FFFFFF" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const toolbar = document.querySelector("#verBtnDescarga");
    const btn = document.createElement("button");
    btn.setAttribute("id", "descargar-zip");
    btn.className = "none";
    btn.innerHTML = iconSvgDescargar+'<span>Descargar</span>';
    btn.onclick = openModal;
    toolbar.appendChild(btn);

const modalHTML = `
<div id="whatsappModal" style="display:none; position:fixed; inset:0; background:#0008; z-index:9999; align-items:center; justify-content:center;">
  <div style="position:relative; background:#fff; width:90%; max-width:900px; padding:20px 24px 24px; border-radius:12px; overflow:auto; max-height:90%; box-shadow:0 10px 30px rgba(0,0,0,.2);">
    
    <!-- Botón X arriba-derecha -->
    <button id="closeModalBtn" aria-label="Cerrar" title="Cerrar"
      style="position:absolute; top:10px; right:10px; background:transparent; border:none; font-size:22px; line-height:1; cursor:pointer;">
      ×
    </button>

    <h5 style="margin:0 0 12px; font-size:18px; font-weight:600;">Selecciona las Referencias</h5>
    <div style="margin-top:18px; display:flex; gap:10px; flex-wrap:wrap;">
      <button id="downloadZipBtn" style="background:#28a745; color:#fff; padding:10px 18px; border:none; border-radius:8px; cursor:pointer;">Descargar(ZIP)</button>
      <button id="selectAllBtn" style="padding:8px 12px; border-radius:8px; border:1px solid #ddd; background:#f8f8f8; cursor:pointer;">
        Seleccionar todas
      </button>
      <span id="selectionCount" style="font-weight:500;">0 seleccionadas</span>
      <button id="catalogoBtn"   style="background:#000;    color:#fff; padding:10px 18px; border:none; border-radius:8px; cursor:pointer;">Catálogo(PDF)</button>
      <button id="closeModalBtn2" style="padding:10px 18px; border-radius:8px; border:1px solid #ddd; background:#f8f8f8; cursor:pointer;">Cerrar</button>
    </div>

    <div id="imageGrid" style="display:flex; flex-wrap:wrap; gap:12px;"></div>


  </div>
</div>`;
  
    document.getElementById("whatsapp-modal-container").innerHTML = modalHTML;

/**  
    // Verifica si accesoPermitido es true
    const acceso = localStorage.getItem("accesoPermitido");
    if (acceso === "true") {
      const boton = document.getElementById("descargar-zip");
      if (boton) {
        boton.classList.remove("none");
      }
    }  
**/
      const boton = document.getElementById("descargar-zip");
      if (boton) {
        boton.classList.remove("none");
      }



  
}); // <== Cierre de DOMContentLoaded ✅